import React from 'react';
import { useState } from 'react';

import Modal from '../../../components/Modal/Modal';

import closeBtn from '../../../img/close-btn.svg';
import backBtn from '../../../img/back_btn.svg';
import QuestionContent from './QuestionContent';

import './question.scss';

import { createUseStyles } from "react-jss";
import Tooltip from '../../tooltip/Tooltip';

const useStales = createUseStyles({
    backBlock: {
        position: 'absolute',
        bottom: 20,
        right: 20
    },
    backBtn: {
        backgroundImage: `url(${backBtn})`,
        backgroundSize: 'cover',
        border: 'none',
        outline: 'none',
        width: 21,
        height: 21,
        backgroundColor: 'inherit',
        backgroundPosition: 'center',
        cursor: 'pointer',
    },
    backText: {
        verticalAlign: 'top',
        fontSize: 20,
    },
    accountEmailError: {
        color: '#B5463C',
        margin: 0,
        fontSize: 13
    },
    btnRevers: {
        backgroundImage: `url(${backBtn})`,
        backgroundSize: 'cover',
        border: 'none',
        outline: 'none',
        width: 21,
        height: 21,
        backgroundColor: 'inherit',
        backgroundPosition: 'center',
        cursor: 'pointer',
        transform: 'scaleX(-1)',
        transformOrigin: 'center',
        transformBox: 'fill-box',
    }

})

const Question = () => {
    const [showModal, setShowModal] = useState(false);
    const [modalName, setModalName] = useState('info');
    const [page, setPage] = useState(0);
    const classes = useStales();

    const handleToggleModal = () => {
        setShowModal(!showModal);
        setPage(0);
    };

    const tooltipContent = () => {
        return (
            <div>
                <p style={{ margin: 0 }}>Info</p>
            </div>
        )
    }

    return (
        <>
            <div className='question-block_wrapper'>
                <Tooltip
                    content={tooltipContent()}
                    direction="left"
                    dirStyle="infoBottom"
                >
                    <button className='question-link' onClick={() => handleToggleModal()}>?</button>
                </Tooltip >
            </div>
            {showModal && (
                <Modal toggleModal={handleToggleModal} width={modalName}>

                    <div className='reticleCardInfo__modal-section'>
                        <div style={{ textAlign: 'start' }}>
                            <h1 style={{ marginTop: 0, fontSize: 20 }}>Reticle Editor guide</h1>
                            <button onClick={handleToggleModal} className='modal__btn'>
                                <img className='modal__svg' src={closeBtn} alt='close button svg' />
                            </button>
                        </div>

                        <div className={classes.infoBlock}>
                            <QuestionContent page={page} />
                        </div>


                        <div style={{ textAlign: 'end' }}>
                            <div className={classes.backBlock}>
                                {page !== 0 && (
                                    <button style={{ marginRight: page === 6 ? 61 : 40 }} className={classes.backBtn} onClick={() => setPage(page - 1)}></button>
                                )}
                                {page !== 6 && (
                                    <button className={classes.btnRevers} onClick={() => setPage(page + 1)}></button>
                                )}
                            </div>
                        </div>

                    </div>
                </Modal>
            )}
        </>
    )
}

export default Question;
